// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"528":"Sudoku","798":"Footer"}[chunkId] || chunkId) + "." + {"80":"512e5e97","528":"0c8a597d","606":"cfa9cb4e","798":"e7a82fd0","801":"eb353f48","838":"f5954ce1"}[chunkId] + ".chunk.js";
};